"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useScrollOnError;
var _react = require("react");
var getDocumentAndWindowFromElement = function getDocumentAndWindowFromElement(_ref) {
  var ownerDocument = _ref.ownerDocument;
  return {
    document: ownerDocument,
    window: ownerDocument.defaultView || ownerDocument.parentWindow
  };
};
var isOnView = function isOnView(input) {
  var inputBoundingRect = input.getBoundingClientRect();
  var _getDocumentAndWindow = getDocumentAndWindowFromElement(input),
    window = _getDocumentAndWindow.window,
    document = _getDocumentAndWindow.document;
  return inputBoundingRect.top >= 0 && inputBoundingRect.left >= 0 && inputBoundingRect.bottom <= (window && window.innerHeight || document.documentElement.clientHeight) && inputBoundingRect.right <= (window && window.innerWidth || document.documentElement.clientWidth);
};
var executeScrollToElement = function executeScrollToElement(current) {
  var inputElement = current.querySelector("[aria-invalid='true']");
  if (inputElement) {
    var elementToBeScrolledTo = inputElement.closest("[name='fieldWrapper']") || inputElement;
    if (!isOnView(elementToBeScrolledTo)) {
      elementToBeScrolledTo.scrollIntoView({
        behavior: 'smooth'
      });
    }
    inputElement.focus({
      preventScroll: true
    });
  }
};
function useScrollOnError(_ref2) {
  var errors = _ref2.errors,
    ref = _ref2.ref;
  (0, _react.useEffect)(function () {
    var errorsValues = Object.values(errors);
    var current = ref.current;
    if (errorsValues.length && current) {
      setTimeout(function () {
        return executeScrollToElement(current);
      });
    }
  }, [errors]);
}